var _style, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#338AF3;}\n\t.st2{fill:#000000;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,178.1C4.2,202.7,0,228.8,0,256c0,27.2,4.2,53.3,12.1,77.9L256,345l243.9-11.1 c7.8-24.6,12.1-50.7,12.1-77.9c0-27.2-4.2-53.3-12.1-77.9L256,167L12.1,178.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M512,256c0-15.2-1.3-30.1-3.9-44.5H3.9C1.3,225.9,0,240.8,0,256s1.3,30.1,3.9,44.5h504.3C510.7,286.1,512,271.2,512,256z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,512c114.2,0,210.9-74.8,243.9-178.1H12.1C45.1,437.2,141.8,512,256,512L256,512z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0C141.8,0,45.1,74.8,12.1,178.1l487.8,0C466.9,74.8,370.2,0,256,0L256,0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBw);
export default __webpack_public_path__ + "static/media/bw.b9d6eed4c3ea97ed9a2be543c36b4743.svg";
export { ForwardRef as ReactComponent };